import { render, staticRenderFns } from "./CategoryManagement.vue?vue&type=template&id=d4d147ee&scoped=true"
import script from "./CategoryManagement.vue?vue&type=script&lang=js"
export * from "./CategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./CategoryManagement.vue?vue&type=style&index=0&id=d4d147ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d147ee",
  null
  
)

export default component.exports